export default "__VITE_ASSET__CsEMyB2X__"